import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import '../flow-workbench.css';
import CustomNode from './CustomNode';
const initialNodes = [
  { id: '1', position: { x: 100, y: 0 }, type: 'custom', data: { label: 'Start' } },
  { id: '2', position: { x: 100, y: 120 }, type: 'custom', data: { label: 'Next' } },
];

const initialEdges = [{ id: 'e1-2', source: '1', target: '2' }];



function Flow(){
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes.map(n=>({
    ...n,
    data:{...n.data,onUpdate: handleUpdateNode, onDelete: handleDeleteNode}
  })));
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [nodeCounter, setNodeCounter] = useState(3);
  const [selected, setSelected] = useState({nodes:[], edges:[]});
  const [selectedType, setSelectedType] = useState('employee');
  const [formFields, setFormFields] = useState([]);
  const mountedRef = useRef(false);
  const loadingRef = useRef(false);
  const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [setEdges]);
  useEffect(()=>{
    const rawFields = localStorage.getItem('formFields');
    if (rawFields) {
      try { setFormFields(JSON.parse(rawFields)); } catch(e) {}
    }
    const handleFieldsChange = (e) => {
      if (e.key === 'formFields' || !e.key) {
        const raw = localStorage.getItem('formFields');
        if (raw) { try { setFormFields(JSON.parse(raw)); } catch(e2) {} }
      }
    };
    window.addEventListener('storage', handleFieldsChange);
    window.addEventListener('formFieldsUpdate', () => {
      const raw = localStorage.getItem('formFields');
      if (raw) { try { setFormFields(JSON.parse(raw)); } catch(e2) {} }
    });
    return () => {
      window.removeEventListener('storage', handleFieldsChange);
    };
  }, []);
  useEffect(()=>{
    const loadFlow = () => {
      loadingRef.current = true;
      const raw = localStorage.getItem('flow');
      const rawFields = localStorage.getItem('formFields');
      let fields = [];
      if (rawFields) { try { fields = JSON.parse(rawFields); } catch(e) {} }
      if(raw){
        try{
          const parsed = JSON.parse(raw);
          if(parsed.nodes) {
            setNodes(parsed.nodes.map(n=>({
              ...n,
              data:{...n.data, type: n.data.type || 'employee', formFields: fields, onUpdate:handleUpdateNode, onDelete:handleDeleteNode}
            })));
            const maxId = Math.max(...parsed.nodes.map(n => parseInt(n.id) || 0));
            setNodeCounter(maxId + 1);
          }
          if(parsed.edges) setEdges(parsed.edges);
        }catch(e){}
      } else {
        setNodes(initialNodes.map(n=>({
          ...n,
          data:{...n.data, type: n.data.type || 'employee', formFields: fields, onUpdate:handleUpdateNode, onDelete:handleDeleteNode}
        })));
        setEdges(initialEdges);
        setNodeCounter(3);
      }
      setTimeout(() => {
        loadingRef.current = false;
        mountedRef.current = true;
      }, 100);
    };
    
    loadFlow();
    
    const handleStorageChange = (e) => {
      if (e.key === 'flow' || !e.key) {
        loadFlow();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('flowReload', loadFlow);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('flowReload', loadFlow);
    };
  },[]);
  useEffect(()=>{
    if(!mountedRef.current || loadingRef.current) return;
    const payload = {nodes, edges};
    localStorage.setItem('flow', JSON.stringify(payload));
  },[nodes, edges]);
  useEffect(()=>{
    setNodes(ns => ns.map(n => ({...n, data:{...n.data, formFields, onUpdate: handleUpdateNode, onDelete: handleDeleteNode}})));
  },[formFields]);
  useEffect(() => {
    const onKey = (e) => {
      const active = document.activeElement;
      const tag = active && active.tagName ? active.tagName.toLowerCase() : null;
      const isEditable = active && (active.isContentEditable || tag === 'input' || tag === 'textarea' || tag === 'select');
      const inSuggest = active && (active.closest && (active.closest('.employee-suggest') || active.closest('.employee-suggest-portal')));
      if (isEditable || inSuggest) return;
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (selected.nodes.length || selected.edges.length) {
          const nodesToDeleteSet = new Set(selected.nodes);
          const actualNodesToDelete = new Set();
          for (const n of nodes) {
            if (nodesToDeleteSet.has(n.id) && n.data && n.data.label !== 'Start') actualNodesToDelete.add(n.id);
          }
          setNodes(ns => ns.filter(n => !actualNodesToDelete.has(n.id)));
          setEdges(es => es.filter(e => !selected.edges.includes(e.id) && !actualNodesToDelete.has(e.source) && !actualNodesToDelete.has(e.target)));
          setSelected({ nodes: [], edges: [] });
        }
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selected, nodes]);
  const nodeTypes = { custom: CustomNode };
  const handleAddNode = () => {
    const id = String(nodeCounter);
    
    let newPosition = { x: 100, y: 120 };
    let sourceNodeId = null;
    
    if (nodes.length > 0) {
      const sortedNodes = [...nodes].sort((a, b) => b.position.y - a.position.y);
      const lastNode = sortedNodes[0];
      newPosition = { 
        x: lastNode.position.x, 
        y: lastNode.position.y + 150 
      };
      sourceNodeId = lastNode.id;
    }
    
    const newNode = { 
      id, 
      position: newPosition, 
      data: { label: `Approval ${nodeCounter - 2}`, type: selectedType, formFields, onUpdate: handleUpdateNode, onDelete: handleDeleteNode }, 
      type: 'custom' 
    };
    
    setNodes((nds) => [...nds, newNode]);
    
    if (sourceNodeId) {
      const newEdge = { 
        id: `e${sourceNodeId}-${id}`, 
        source: sourceNodeId, 
        target: id 
      };
      setEdges((eds) => [...eds, newEdge]);
    }
    
    setNodeCounter(c => c + 1);
  };
  function handleUpdateNode(id, payload) {
    setNodes(ns => ns.map(n => {
      if (n.id !== id) return n;
      const currentData = n.data || {};
      let changed = false;
      for (const k of Object.keys(payload || {})) {
        if (currentData[k] !== payload[k]) {
          changed = true;
          break;
        }
      }
      if (!changed) {
        if (currentData.onUpdate !== handleUpdateNode || currentData.onDelete !== handleDeleteNode) {
          return { ...n, data: { ...currentData, onUpdate: handleUpdateNode, onDelete: handleDeleteNode } };
        }
        return n;
      }
      return { ...n, data: { ...currentData, ...payload, onUpdate: handleUpdateNode, onDelete: handleDeleteNode } };
    }));
  }
  function handleDeleteNode(id) {
    const node = nodes.find(n => n.id === id);
    if (node && node.data && node.data.label === 'Start') return;
    setNodes(ns => ns.filter(n => n.id !== id));
    setEdges(es => es.filter(e => e.source !== id && e.target !== id));
  }
  const handleExport = () => {
    const out = JSON.stringify({ nodes, edges }, null, 2);
    const el = document.createElement('a');
    el.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(out);
    el.download = 'flow.json';
    el.click();
  };

  const handleImport = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const parsed = JSON.parse(e.target.result);
        if (parsed.nodes) setNodes(parsed.nodes.map(n => ({ ...n, data: { ...n.data, type: n.data.type || 'employee', formFields, onUpdate: handleUpdateNode, onDelete: handleDeleteNode } })));
        if (parsed.edges) setEdges(parsed.edges);
      } catch (e) {
        console.error(e);
      }
    };
    reader.readAsText(file);
  };
  return (
    <div className="flow-root">
      <div className="toolbar">
        <div className="brand">Request Flow Builder</div>
        <div className="actions">
        <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,marginRight:8}}>
          <option value="employee">Employee</option>
          <option value="general">General</option>
          <option value="department">Department</option>
          <option value="hod">Creator's HOD</option>
          <option value="hod_reportee">Reportee to Creator's HOD</option>
        </select>
        <button onClick={handleAddNode} style={{padding:'8px 12px',background:'#0366d6',color:'#fff',border:'none',borderRadius:6,cursor:'pointer'}}>Add Node</button>
        <button onClick={handleExport} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,cursor:'pointer'}}>Export</button>
        <label style={{display:'inline-block',padding:'8px 12px',border:'1px dashed #ddd',borderRadius:6,cursor:'pointer'}}>
          Import
          <input onChange={(e)=>handleImport(e.target.files && e.target.files[0])} type="file" accept=".json" style={{display:'none'}} />
        </label>
        <button onClick={()=>{
            const idsToKeep = new Set(nodes.filter(n=> n.data && n.data.label === 'Start').map(n=>n.id));
            setNodes(ns => ns.filter(n=> idsToKeep.has(n.id)));
            setEdges(es => es.filter(e => idsToKeep.has(e.source) && idsToKeep.has(e.target)));
          }} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,cursor:'pointer',background:'#fff', color:'#111'}}>Clear</button>
        <button disabled={!((selected.nodes || []).some(id => {
            const n = nodes.find(x => x.id === id);
            return n && n.data && n.data.label !== 'Start';
          }) || (selected.edges && selected.edges.length))}
          onClick={()=>{
            const nodesToDeleteSet = new Set(selected.nodes);
            const actualNodesToDelete = new Set();
            for(const n of nodes){
              if(nodesToDeleteSet.has(n.id) && n.data && n.data.label !== 'Start') actualNodesToDelete.add(n.id);
            }
            setNodes(ns => ns.filter(n=> !actualNodesToDelete.has(n.id)));
            setEdges(es => es.filter(e=> !selected.edges.includes(e.id) && !actualNodesToDelete.has(e.source) && !actualNodesToDelete.has(e.target)));
            setSelected({nodes:[], edges:[]});
          }} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,cursor:'pointer',background:'#fff', color:'#111'}}>Delete Selected</button>
        </div>
      </div>
      <div className="workbench">
        <div className="canvas-area">
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          onSelectionChange={(s)=>{
            const newNodes = (s.nodes||[]).map(n=>n.id);
            const newEdges = (s.edges||[]).map(e=>e.id);
            setSelected(prev=>{
              const sameNodes = prev.nodes.length === newNodes.length && newNodes.every(id => prev.nodes.includes(id));
              const sameEdges = prev.edges.length === newEdges.length && newEdges.every(id => prev.edges.includes(id));
              if(sameNodes && sameEdges) return prev;
              return {nodes: newNodes, edges: newEdges};
            });
          }}
          nodeTypes={nodeTypes}
        >
          <MiniMap />
          <Controls />
          <Background />
        </ReactFlow>
        </div>
      </div>
    </div>
  );
}

export default Flow;